import type { Router } from "vue-router";
import { TRANSLATION_LOADERS } from "../utils/i18next";
import { isPreviewMode } from "./mode";

const PRELOAD_DELAY = 1000;

const isThenable = (value: unknown): value is PromiseLike<unknown> => !!value && typeof (value as { then?: unknown }).then === "function";

const isLazyLoader = (component: unknown): component is () => unknown =>
	typeof component === "function" && component.length === 0 && !("displayName" in component) && !("props" in component) && !("__vccOpts" in component);

const settle = (value: unknown) => {
	if (isThenable(value)) void Promise.resolve(value).catch(() => {});
};

const preloadRouteComponents = (router: Router) => {
	for (const record of router.getRoutes()) {
		for (const component of Object.values(record.components ?? {})) {
			if (isLazyLoader(component)) settle(component());
		}
	}
};

const preloadTranslations = () => {
	for (const load of Object.values(TRANSLATION_LOADERS)) settle(load());
};

export const preloadLazyRoutes = (router: Router, { always = false }: { always?: boolean } = {}) => {
	if (!isPreviewMode && !always) return;
	const preload = () => {
		preloadRouteComponents(router);
		if (isPreviewMode) preloadTranslations();
	};
	void router
		.isReady()
		.catch(() => {})
		.then(() => window.setTimeout(preload, PRELOAD_DELAY));
};
